export default {
  pluralDowncase: 'statuses',
  select: 'Select status...',
  change: 'Change status',
  set: 'Set status',
  initialStatus: 'Initial status',
  types: {
    acceptance: 'Ready for acceptance',
    canceled: 'Canceled',
    checking: 'Checking task',
    definition: 'Setting task',
    discussion: 'Discussion',
    distribution: 'Distribution',
    implementation: 'In progress',
    incompleteSpecification: 'Pending more info',
    paid: 'Paid',
    paused: 'Paused',
    paymentWaiting: 'Pending payment',
    performed: 'Done',
    qa: 'Quality control'
  }
};
